export enum OtpVerificationType {
  LOGIN = 'login',
  FORGOT_PASSWORD = 'forgot-password',
}
